/**
 * Product Picker - buscador de productos en vivo (todo el catálogo, no solo lo cargado en la página).
 * Las categorías se generan automáticamente a partir del "Tipo de producto" de cada producto en Shopify.
 * Usa /cart/add.js (AJAX), que quote-generator.js ya detecta automáticamente para refrescar su vista previa.
 */
(function () {
  var settings = window.productPickerSettings || {};
  var searchInput = document.getElementById('pp-search');
  var categoriesEl = document.getElementById('pp-categories');
  var resultsEl = document.getElementById('pp-results');
  var statusEl = document.getElementById('pp-status');

  if (!searchInput || !resultsEl) return; // la sección no está en esta página

  var debounceTimer = null;
  var currentRequestToken = 0;
  var productCache = {}; // handle -> producto completo (de /products/{handle}.js)
  var currentCategoryType = ''; // '' = "Todos" (la colección por defecto)

  function setStatus(msg, isError) {
    statusEl.textContent = msg;
    statusEl.className = 'pp-status' + (isError ? ' pp-status--error' : '');
  }

  searchInput.addEventListener('input', function () {
    var term = searchInput.value.trim();
    clearTimeout(debounceTimer);

    if (term.length < 2) {
      loadCategoryResults(currentCategoryType);
      return;
    }

    debounceTimer = setTimeout(function () { runSearch(term); }, 300);
  });

  // Botones de categoría (uno por cada "Tipo de producto" que exista en tu catálogo).
  if (categoriesEl) {
    categoriesEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.pp-category-btn');
      if (!btn) return;

      var buttons = categoriesEl.querySelectorAll('.pp-category-btn');
      for (var i = 0; i < buttons.length; i++) buttons[i].classList.remove('active');
      btn.classList.add('active');

      searchInput.value = '';
      loadCategoryResults(btn.dataset.type);
    });
  }

  // Punto de entrada según la categoría activa: "" (Todos) carga la colección por defecto,
  // cualquier otro valor busca productos de ese tipo.
  function loadCategoryResults(type) {
    currentCategoryType = type || '';

    if (!currentCategoryType) {
      loadDefaultResults();
      return;
    }

    var limit = settings.resultsLimit || 8;
    resultsEl.innerHTML = '<p class="pp-empty">Cargando productos...</p>';

    var q = 'product_type:"' + currentCategoryType.replace(/"/g, '') + '"';
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product' +
      '&resources[limit]=' + limit +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products);
      })
      .catch(function (err) {
        console.error('[product-picker]', err);
        resultsEl.innerHTML = '';
      });
  }

  // Muestra unos productos al abrir la página / al tocar "Todos" / al borrar la búsqueda.
  function loadDefaultResults() {
    var handle = settings.defaultCollectionHandle || 'all';
    var limit = settings.resultsLimit || 8;

    resultsEl.innerHTML = '<p class="pp-empty">Cargando productos...</p>';

    fetch('/collections/' + handle + '/products.json?limit=' + limit)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data.products || []).map(normalizeCollectionProduct);
        renderResults(products);
      })
      .catch(function (err) {
        console.error('[product-picker]', err);
        resultsEl.innerHTML = '';
      });
  }

  // Convierte el formato de /collections/{handle}/products.json (precios en texto, ej. "12.00")
  // al mismo formato { title, handle, image, price } que usan los resultados de búsqueda.
  function normalizeCollectionProduct(product) {
    var image = product.images && product.images.length ? product.images[0].src : null;
    var price = '';
    if (product.variants && product.variants.length) {
      price = '$' + parseFloat(product.variants[0].price).toFixed(2);
    }
    return { title: product.title, handle: product.handle, image: image, price: price };
  }

  loadDefaultResults();

  function runSearch(term) {
    var token = ++currentRequestToken;
    resultsEl.innerHTML = '<p class="pp-empty">Buscando...</p>';

    var url = '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product' +
      '&resources[limit]=' + (settings.resultsLimit || 8) +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (token !== currentRequestToken) return; // llegó una búsqueda más nueva mientras tanto
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products);
      })
      .catch(function (err) {
        console.error('[product-picker]', err);
        if (token === currentRequestToken) {
          resultsEl.innerHTML = '<p class="pp-empty">Error al buscar. Intenta de nuevo.</p>';
        }
      });
  }

  function renderResults(products) {
    if (!products.length) {
      resultsEl.innerHTML = '<p class="pp-empty">Sin resultados.</p>';
      return;
    }

    resultsEl.innerHTML = '';
    products.forEach(function (product) {
      resultsEl.appendChild(buildResultCard(product));
    });
  }

  function buildResultCard(product) {
    var card = document.createElement('div');
    card.className = 'pp-result';
    card.innerHTML =
      '<div class="pp-result__image">' +
        (product.image ? '<img src="' + product.image + '" alt="" loading="lazy">' : '<span>Sin imagen</span>') +
      '</div>' +
      '<div class="pp-result__body">' +
        '<p class="pp-result__title"></p>' +
        '<p class="pp-result__price"></p>' +
        '<button type="button" class="pp-toggle-btn">Seleccionar</button>' +
        '<div class="pp-result__controls">' +
          '<div class="pp-variant-slot"></div>' +
          '<div class="pp-row">' +
            '<input type="number" class="pp-qty" value="1" min="1">' +
            '<button type="button" class="pp-add-btn">Agregar al carrito</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    card.querySelector('.pp-result__title').textContent = product.title;
    card.querySelector('.pp-result__price').textContent = product.price || '';

    var toggleBtn = card.querySelector('.pp-toggle-btn');
    toggleBtn.addEventListener('click', function () {
      var expanding = !card.classList.contains('pp-expanded');
      card.classList.toggle('pp-expanded', expanding);
      toggleBtn.textContent = expanding ? 'Ocultar opciones' : 'Seleccionar';
      if (expanding) loadVariants(product, card);
    });

    return card;
  }

  function loadVariants(product, card) {
    var slot = card.querySelector('.pp-variant-slot');

    if (productCache[product.handle]) {
      renderVariantControls(productCache[product.handle], card);
      return;
    }

    slot.innerHTML = '<p class="pp-empty">Cargando opciones...</p>';

    fetch('/products/' + product.handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (fullProduct) {
        productCache[product.handle] = fullProduct;
        renderVariantControls(fullProduct, card);
      })
      .catch(function (err) {
        console.error('[product-picker]', err);
        slot.innerHTML = '<p class="pp-empty">No se pudieron cargar las opciones.</p>';
      });
  }

  function renderVariantControls(fullProduct, card) {
    var slot = card.querySelector('.pp-variant-slot');
    var addBtn = card.querySelector('.pp-add-btn');
    var qtyInput = card.querySelector('.pp-qty');
    var priceEl = card.querySelector('.pp-result__price');

    slot.innerHTML = '';

    var select = null;
    if (fullProduct.variants.length > 1) {
      select = document.createElement('select');
      select.className = 'pp-variant-select';
      fullProduct.variants.forEach(function (variant) {
        var opt = document.createElement('option');
        opt.value = variant.id;
        opt.disabled = !variant.available;
        opt.textContent = variant.title + (variant.available ? '' : ' (Agotado)') + ' — ' + formatMoneyFromCents(variant.price);
        select.appendChild(opt);
      });
      slot.appendChild(select);

      select.addEventListener('change', function () {
        var variant = fullProduct.variants.filter(function (v) { return String(v.id) === select.value; })[0];
        updatePriceAndButton(variant);
      });

      updatePriceAndButton(fullProduct.variants[0]);
    } else {
      updatePriceAndButton(fullProduct.variants[0]);
    }

    function updatePriceAndButton(variant) {
      priceEl.textContent = formatMoneyFromCents(variant.price);
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
    }

    addBtn.onclick = function () {
      var variantId = select ? select.value : fullProduct.variants[0].id;
      var qty = parseInt(qtyInput.value, 10) || 1;
      addToCart(variantId, qty, fullProduct.title, addBtn);
    };
  }

  function formatMoneyFromCents(cents) {
    var value = (cents / 100).toFixed(2);
    return '$' + value;
  }

  function addToCart(variantId, qty, title, btn) {
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Agregando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Error al agregar'); });
        return res.json();
      })
      .then(function () {
        setStatus('Agregado: ' + title + ' x' + qty);
        btn.textContent = 'Agregado ✓';
        btn.classList.add('pp-added');
        setTimeout(function () {
          btn.textContent = originalText;
          btn.classList.remove('pp-added');
          btn.disabled = false;
        }, 1200);
      })
      .catch(function (err) {
        console.error('[product-picker]', err);
        setStatus('Error: ' + err.message, true);
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }
})();